import Vue from 'vue';
import InlineSvgComponent from 'vue-inline-svg';
import { ConfigProgrammatic, Toast as ToasPlugin } from 'buefy';

Vue.use(ToasPlugin);
ConfigProgrammatic.setOptions({
    defaultToastPosition: 'is-bottom',
    defaultContainerElement: '.panel.panel__overlay.panel--show',
}); //container

export const InlineSvg = InlineSvgComponent;
export const Toast = Vue.prototype.$buefy.toast;
delete Vue.prototype.$buefy;
export const Components_UI = ((x) => x.keys().map(x))(require.context('./components_ui', true, /^.*.vue$/));
export const Images = require.context('../public/images', true);
export const ToNumber = (value) => parseFloat(value) || null;
